module.exports = __webpack_public_path__ + "img/waishenhe.bdc4783d.jpg";